import { useState, useEffect } from "react";
import { Box, Container, Grid, Typography, Link } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { styles } from "./styles";

export const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [isVending, setIsVending] = useState(
    location.pathname.includes("vending")
  );

  useEffect(() => {
    setIsVending(location.pathname.includes("vending"));
  }, [location.pathname]);

  const footerLinks = [
    { label: "About Us", path: isVending ? "/vending/about" : "/about" },
    { label: "Contact Us", path: isVending ? "/vending/contact" : "/contact" },
  ];

  const phone1 = { label: "(713) 550-4133", href: "tel:7135504133" };
  const phone2 = { label: "(713) 581-0698", href: "tel:7135810698" };
  const email = {
    label: "contact@globalga.co",
    href: "mailto:contact@globalga.co",
  };

  const handleNavigate = (path :string) => {
    navigate(path);
  };

  return (
    <Box
      sx={{
        ...styles.footer,
        bgcolor: "#000", // Full black background
        color: "#fff", // White text
        borderTop: "1px solid #222",
      }}
    >
      <Container
        maxWidth={false}
        sx={{ px: { xs: 2, md: 8 }, maxWidth: "1400px" }}
      >
        <Grid container spacing={4} alignItems="center" sx={styles.row}>
          {/* Left: About Us, Phone 1 */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: { xs: "center", md: "flex-start" },
                alignItems: { xs: "center", md: "flex-start" },
                height: "100%",
                textAlign: { xs: "center", md: "left" },
                gap: 1.2,
              }}
            >
              <Typography sx={styles.text} component="span">
                <Link
                  onClick={() => handleNavigate(footerLinks[0].path)}
                  color="inherit"
                  underline="hover"
                  sx={{ color: "#fff", cursor: "pointer" }}
                >
                  {footerLinks[0].label}
                </Link>
              </Typography>
              <Typography sx={styles.text} component="span">
                <Link
                  href={phone1.href}
                  color="inherit"
                  underline="hover"
                  sx={{ color: "#fff" }}
                >
                  {phone1.label}
                </Link>
              </Typography>
            </Box>
          </Grid>
          {/* Center: Email, Copyright */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                height: "100%",
                textAlign: "center",
                gap: 1.2,
              }}
            >
              <Typography sx={styles.text} component="span">
                <Link
                  href={email.href}
                  color="inherit"
                  underline="hover"
                  sx={{ color: "#fff" }}
                >
                  {email.label}
                </Link>
              </Typography>
              <Typography sx={styles.text} component="span">
                <Typography
                  sx={{
                    ...styles.text,
                    width: "100%",
                    textAlign: { xs: "center", md: "right" },
                    color: "#fff",
                  }}
                >
                  © {new Date().getFullYear()} Global GA LLC. All rights
                  reserved.
                </Typography>
              </Typography>
            </Box>
          </Grid>
          {/* Right: Contact Us, Phone 2 */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: { xs: "center", md: "flex-end" },
                justifyContent: "center",
                height: "100%",
                textAlign: { xs: "center", md: "right" },
                width: "100%",
                gap: 1.2,
              }}
            >
              <Typography sx={styles.text} component="span">
                <Link
                  onClick={() => handleNavigate(footerLinks[1].path)}
                  color="inherit"
                  underline="hover"
                  sx={{ color: "#fff", cursor: "pointer" }}
                >
                  {footerLinks[1].label}
                </Link>
              </Typography>
              <Typography sx={styles.text} component="span">
                <Link
                  href={phone2.href}
                  color="inherit"
                  underline="hover"
                  sx={{ color: "#fff" }}
                >
                  {phone2.label}
                </Link>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
